import { z } from 'zod'

export const createTbankConnectionSchema = z
  .object({
    name: z.string().min(1).max(50),
    isSandbox: z.boolean(), // sandbox or production (real) account
    token: z.string().min(10).max(200),
    sandboxMode: z.enum(['create-new', 'pick-existing']).optional(),
    initialBalance: z.number().positive().max(30_000_000).optional(), // RUB, sandbox create-new only
    tbankAccountId: z.string().min(1).optional(), // sandbox pick-existing only
  })
  .superRefine((data, ctx) => {
    if (!data.isSandbox) return
    if (!data.sandboxMode) {
      ctx.addIssue({
        code: 'custom',
        path: ['sandboxMode'],
        message: 'sandboxMode is required for a sandbox connection',
      })
      return
    }
    if (data.sandboxMode === 'pick-existing' && !data.tbankAccountId) {
      ctx.addIssue({
        code: 'custom',
        path: ['tbankAccountId'],
        message: 'tbankAccountId is required when picking an existing account',
      })
    }
  })

export type CreateTbankConnectionDto = z.infer<typeof createTbankConnectionSchema>
